import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Gift, X as IconX } from 'lucide-react';

/**
 * @file Componente para o modal "O que há de novo".
 * Exibe as novidades da versão atual da aplicação.
 *
 * @param {object} props - As propriedades do componente.
 * @param {boolean} props.isOpen - Controla a visibilidade do modal.
 * @param {function} props.onClose - Função chamada quando o modal é fechado. Recebe um booleano indicando se "não mostrar novamente" foi marcado.
 * @param {string} props.version - A string da versão atual para exibir no título.
 * @param {string} props.content - O conteúdo em formato Markdown para ser renderizado.
 */
const WhatsNewModal = ({ isOpen, onClose, version, content }) => {
    const [dontShowAgain, setDontShowAgain] = React.useState(false);

    if (!isOpen) {
        return null;
    }

    const handleClose = () => {
        onClose(dontShowAgain);
    };

    return (
        <div className="fixed inset-0 bg-black/60 z-[1050] flex justify-center items-center p-4 animate-fade-in">
            <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col" onClick={e => e.stopPropagation()}>
                <header className="p-4 border-b border-slate-200 dark:border-slate-700 flex justify-between items-center">
                    <h2 className="text-xl font-bold flex items-center text-slate-800 dark:text-slate-100">
                        <Gift className="mr-3 text-blue-500" />
                        O que há de novo na versão {version}
                    </h2>
                    <button onClick={handleClose} aria-label="Fechar" title="Fechar" className="p-2 rounded-full hover:bg-slate-200 dark:hover:bg-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2">
                        <IconX />
                    </button>
                </header>
                <div className="flex-grow overflow-y-auto p-6 prose dark:prose-invert max-w-none prose-h3:text-lg prose-h3:mb-2 prose-ul:list-disc prose-ul:pl-5 prose-li:mb-1">
                    <ReactMarkdown>{content}</ReactMarkdown>
                </div>
                <footer className="p-4 border-t border-slate-200 dark:border-slate-700 flex justify-between items-center gap-4">
                    <div className="flex items-center">
                        <input
                            id="dont-show-again"
                            type="checkbox"
                            checked={dontShowAgain}
                            onChange={(e) => setDontShowAgain(e.target.checked)}
                            className="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500 dark:bg-slate-800 dark:border-slate-600"
                        />
                        <label htmlFor="dont-show-again" className="ml-2 block text-sm text-slate-700 dark:text-slate-300">
                            Não mostrar novamente
                        </label>
                    </div>
                    <button onClick={handleClose} className="btn-primary">
                        Fechar
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default WhatsNewModal;